import Vue from 'vue';
import { apiErrorStatus, apiFieldErrors, IApiFieldError } from '@/services/identityIntegrationsService';

const MESSAGE_PREFIX = 'identityIntegrations.errors.';

export function collectErrors(error: any): IApiFieldError[] {
  const errors = apiFieldErrors(error);

  if (errors.length) {
    return errors;
  }

  const status = apiErrorStatus(error);

  return [{ title: status ? 'status' + status : 'unexpected', ref: null }];
}

export function errorMessage(vue: Vue, error: IApiFieldError): string {
  // Mayordomo titles some errors with the bare HTTP status ("404", "422"):
  // those read through the same status messages as a response with no body.
  const title = /^\d{3}$/.test(error.title) ? 'status' + error.title : error.title;
  const key = MESSAGE_PREFIX + title;

  if (vue.$te(key)) {
    return vue.$t(key) as string;
  }

  return vue.$t(MESSAGE_PREFIX + 'unexpected') as string;
}

export function fieldErrorMessages(vue: Vue, errors: IApiFieldError[], field: string): string[] {
  return errors.filter((each) => each.ref === field).map((each) => errorMessage(vue, each));
}

export function generalErrorMessage(vue: Vue, errors: IApiFieldError[], mappedFields: string[]): string | null {
  const unmapped = errors.filter((each) => !each.ref || mappedFields.indexOf(each.ref) === -1);

  if (!unmapped.length) {
    return null;
  }

  return errorMessage(vue, unmapped[0]);
}
